import { FC } from 'react';
import { ResourceRequestAssigneeUpdated } from 'api/notifications/meta';
import { resourceRequestMessage } from './resource-request-message';
// import { InlineLink } from '../../basics';

export const ResourceRequestAssigneeUpdatedView: FC<{
  meta: ResourceRequestAssigneeUpdated;
}> = ({ meta: { by, info } }) => {
  return resourceRequestMessage({ by, info });
};
